import { days } from "../../cadendar-consts.js";
const bornesForDay = (horaire, date) => {
    const jour = date.getDay();
    const jourEnLettres = days[jour];
    return horaire.horaire[jourEnLettres] || [];
};
export default bornesForDay;
//# sourceMappingURL=bornesForDay.js.map